import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
    ApiService,
    Mk2Request,
    Mk2Response,
    Pagination
} from '@lsq-frontend/angular-shared/api-service';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { BuyerRelationshipDto } from '../../model/buyer-relationship-dto';
import { SellerRelationshipDto } from '../../model/seller-relationship-dto';
import { SupplierVendorPortalEnrollmentDto } from '../../model/supplier-vendor-portal-enrollment-dto';

export class GetSupplierRelationshipDetailsRequest extends Mk2Request {
    relationshipKey?: string;

    constructor(initial?: Partial<GetSupplierRelationshipDetailsRequest>) {
        super();
        if (initial != null) {
            Object.keys(initial).forEach((key) => {
                this[key] = initial[key];
            });
        }
    }
}

export class GetSupplierRelationshipDetailsResponse extends Mk2Response {
    active?: boolean;
    allSellerRelationships?: SellerRelationshipDto[];
    buyerDecayingFeeDailyRatePercent?: number;
    buyerDefaultFlatFeeRatePercent?: number;
    buyerIneligibleDaysBeforeTerms?: number;
    buyerKey?: string;
    buyerPaidEarlyPaymentFees?: number;
    buyerPaidTransferFees?: boolean;
    buyerRelationships?: BuyerRelationshipDto[];
    defaultIneligibleDaysBeforeTerms?: string;
    eligible?: boolean;
    platformDecayingFeeDailyRatePercent?: number;
    platformIneligibleDaysBeforeTerms?: number;
    relationshipBuyerPaidEarlyPaymentFees?: number;
    relationshipBuyerPaidTransferFees?: boolean;
    relationshipDecayingFeeDailyRatePercent?: number;
    relationshipFlatFeeRatePercent?: number;
    relationshipIneligibleDaysBeforeTerms?: number;
    relationshipKey?: string;
    supplierCompanyKey?: string;
    supplierEnrollments?: SupplierVendorPortalEnrollmentDto[];
    supplierKey?: string;
    supplierLegalName?: string;
    supplierPreferredName?: string;

    constructor(initial?: Partial<GetSupplierRelationshipDetailsResponse>) {
        super();
        if (initial != null) {
            Object.keys(initial).forEach((key) => {
                this[key] = initial[key];
            });
        }
    }
}

@Injectable({ providedIn: 'root' })
export class GetSupplierRelationshipDetailsService extends ApiService<
    GetSupplierRelationshipDetailsRequest,
    GetSupplierRelationshipDetailsResponse
> {
    public requestType = GetSupplierRelationshipDetailsRequest;
    public responseType = GetSupplierRelationshipDetailsResponse;
    public endpointName = 'operations/AdminManageSupplier/GetSupplierRelationshipDetails';
    public serviceName = 'financing';
    constructor(http: HttpClient, @Inject(SETTINGS) settings: ISettings) {
        super(http, settings);
    }
}
